import { render, staticRenderFns } from "./ExamSelectorDialog.vue?vue&type=template&id=2ebc9d30&scoped=true"
import script from "./ExamSelectorDialog.vue?vue&type=script&lang=js"
export * from "./ExamSelectorDialog.vue?vue&type=script&lang=js"
import style0 from "./ExamSelectorDialog.vue?vue&type=style&index=0&id=2ebc9d30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebc9d30",
  null
  
)

export default component.exports